import styled from 'styled-components';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
export const ToggleButton = styled.button`
  height: 28px;
  padding: 0 10px;
  border: none;
  border-radius: 5px;
  font-size: 12px;
  font-family: 'OpenSans-Regular';
  background-color: ${props => props.selected ? 'rgba(166,194,255,0.19)' : '#fff'};
  border-color: ${props => props.selected ? '#002D8E' : '#fff'};
  border: ${props => props.selected ? '1px solid rgba(0, 0, 0, 0.12)' : '#fff'};
`;
export const SlectStyle = styled(Select)`
  width: 177px;
  height: 32px;
  font-size: 12px;
  font-family: 'OpenSans-Regular';
  background-color: #ffffff;
`;
export const MenuItemStyle = styled(MenuItem)`
  .muiselect-outlined.muiselect-outlined {
    background-color: #ffffff;
  }
`;